import React, { useState } from "react";

interface HeaderProps {
  onReset?: () => void;
  resetButtonText?: string;
}

export const Header: React.FC<HeaderProps> = ({
  onReset,
  resetButtonText = "Reset",
}) => {
  const [aiMode, setAiMode] = useState<"openai" | "rag">(() => {
    // Load from localStorage or default to openai
    return (localStorage.getItem("aiMode") as "openai" | "rag") || "openai";
  });

  const handleToggle = () => {
    const newMode = aiMode === "openai" ? "rag" : "openai";
    setAiMode(newMode);
    localStorage.setItem("aiMode", newMode);
    // Force page reload to apply new service
    window.location.reload();
  };

  return (
    <header className="bg-white border-b">
      <div className="container mx-auto max-w-2xl py-3 px-4 sm:px-6 flex items-center justify-between">
        <div className="flex items-center space-x-3">
          <img
            src="/assets/autoai-logo.svg"
            alt="AutoAI Logo"
            style={{
              objectFit: "contain",
              maxHeight: "32px",
              maxWidth: "100%",
            }}
          />
          <div className="text-xl font-bold">
            <span className="text-[#1A237E]">Auto</span>
            <span className="text-[#4FC3F7]">AI</span>
          </div>
        </div>

        <div className="flex items-center space-x-4">
          {/* AI Mode Toggle */}
          <div className="flex items-center space-x-2 px-3 py-1.5 bg-gray-50 rounded-lg border border-gray-200">
            <span
              className={`text-xs font-medium ${aiMode === "openai" ? "text-blue-600" : "text-gray-500"}`}
            >
              Fine-Tune
            </span>
            <button
              onClick={handleToggle}
              className={`relative inline-flex h-5 w-9 items-center rounded-full transition-colors focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 ${
                aiMode === "rag" ? "bg-green-600" : "bg-blue-600"
              }`}
              title={`Switch to ${aiMode === "openai" ? "RAG" : "Fine-Tune"} model`}
              aria-label={`Switch to ${aiMode === "openai" ? "RAG" : "Fine-Tune"} model`}
            >
              <span
                className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${
                  aiMode === "rag" ? "translate-x-5" : "translate-x-0.5"
                }`}
              />
            </button>
            <span
              className={`text-xs font-medium ${aiMode === "rag" ? "text-green-600" : "text-gray-500"}`}
            >
              RAG
            </span>
          </div>

          {onReset && (
            <button
              onClick={onReset}
              className="inline-flex items-center px-3 py-2 border border-gray-300 shadow-sm text-sm leading-4 font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
            >
              {resetButtonText}
            </button>
          )}
        </div>
      </div>
    </header>
  );
};
